import { render, staticRenderFns } from "./MaxxSafeConfig.vue?vue&type=template&id=7aea06ec&scoped=true&"
import script from "./MaxxSafeConfig.vue?vue&type=script&lang=js&"
export * from "./MaxxSafeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aea06ec",
  null
  
)

export default component.exports